import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { ClientForm } from "../../features/clients/ClientForm"

type NewClientPageProps = {
  client: {
    cliente: string
    cpf_cnpj_tomador: string
    inscricao_municipal_tomador: string
    inscricao_estadual_tomador: string
    razao_social_tomador: string
    tipo_endereco_tomador: string
    endereco_tomador: string
    numero_endereco_tomador: string
    complemento_endereco_tomador: string
    bairro_tomador: string
    cidade_tomador: string
    uf_tomador: string
    cep_tomador: string
    exterior: boolean
    codigo_sap?: string | null
    cr?: string | null
    omie_n_cod_cli?: string
  }
  errors?: Record<string, string[]>
}

export default function NewClientPage({ client, errors }: NewClientPageProps) {
  return (
    <>
      <Head title="Novo Cliente" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Novo Cliente</h1>
            <p className="text-slate-400">Preencha os dados abaixo para cadastrar um cliente.</p>
          </div>
          <ClientForm initialValues={client} submitUrl="/clientes" submitLabel="Criar cliente" method="post" errors={errors} />
        </div>
      </AppLayout>
    </>
  )
}
